<nav class="my-2 my-md-0 mr-md-3">
  <ng-containter *ngIf="emailAddress !== ''">
    <span><b>Logged In As: {{ emailAddress }}</b></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  </ng-containter>
  <ng-container *ngIf="!loggedIn">
    <a class="p-2 text-dark" [routerLink]="['/login']" (click)="collapse()">
      <span class="fas fa-sign-in-alt"></span>&nbsp;&nbsp;Log In
    </a>
  </ng-container>
  <ng-container *ngIf="!loggedIn">
    <a class="p-2 text-dark" [routerLink]="['/register']" (click)="collapse()">
      <span class="fas fa-user-plus"></span>&nbsp;&nbsp;Register
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && !reportOnly && isInteractiveUser">
    <a class="p-2 text-dark" [routerLink]="['/interactives']">
      <span class="fas fa-chart-bar"></span>&nbsp;&nbsp;My Interactives
    </a>
  </ng-container>
  <!--<ng-container *ngIf="loggedIn && isReportExportUser">
    <a class="p-2 text-dark"
       [routerLink]="['/report-subscriptions']"
       (click)="collapse()">
      <span class="fa fa-clipboard-check"></span>&nbsp;&nbsp;My Reports
    </a>
  </ng-container>-->
  <ng-container *ngIf="loggedIn && hasReportLayouts">
    <a class="p-2 text-dark"
       [routerLink]="['/report-layouts']"
       (click)="collapse()">
      <span class="fa fa-clipboard-check"></span>&nbsp;&nbsp;My Report Layouts
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && hasDodLayouts">
    <a class="p-2 text-dark"
       [routerLink]="['/dod-layouts']"
       (click)="collapse()">
      <span class="fa fa-file-export"></span>&nbsp;&nbsp;My Data Layouts
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && isEmbeddedUser">
    <a class="p-2 text-dark"
       [routerLink]="['/widgets']"
       (click)="collapse()">
      <span class="fa fa-cogs"></span>&nbsp;&nbsp;My Widgets
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn && (isInteractiveUser || isReportExportUser)">
    <a class="p-2 text-dark"
       [routerLink]="['/subscription']"
       (click)="collapse()">
      <span class="fas fa-clipboard-list"></span>&nbsp;&nbsp;My Subscriptions
    </a>
  </ng-container>
  <ng-container *ngIf="loggedIn">
    <a class="p-2 text-dark" href="#" (click)="logOut()">
      <span class="fas fa-sign-out-alt"></span>&nbsp;&nbsp;Log Out
    </a>
  </ng-container>
  <ng-container *ngIf="admin || supportAdmin">
    <a class="p-2 text-dark" [routerLink]="['/admin']" (click)="collapse()">
      <span class="fas fa-cogs"></span>&nbsp;&nbsp;Admin
    </a>
  </ng-container>
</nav>
